import { useSearchParams } from "react-router-dom";
import useFetch from "hooks/useFetch";
import React, { useEffect, useState } from "react";
import { Button, Stack, Typography } from "@mui/joy";
import { CheckLottie } from "../../components/common/CheckLottie";

export default function NewsletterSettings() {
  const [searchParams] = useSearchParams();

  const emailToken = searchParams.get("u");

  const [loading, setLoading] = useState<boolean>(false);
  const [disable, setDisabled] = useState<boolean>(false);
  const [unsubscribed, setUnsubscribed] = useState<boolean>(false);
  const [completedAt, setCompletedAt] = useState<string>("");

  const [dataUnsubscribe, newsletterUnsubscribe] = useFetch({
    url: `/newsletter/unsubscribe`,
    requestBody: JSON.stringify({
      emailToken: emailToken,
    }),
  });

  useEffect(() => {
    if (dataUnsubscribe?.code === 0) {
      setLoading(false);
      setDisabled(true);
      setUnsubscribed(true);
      const d = new Date();
      const formatted = new Intl.DateTimeFormat("ko-KR", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      }).format(d);
      setCompletedAt(formatted);
    }
  }, [dataUnsubscribe]);

  const handleUnsubscribe = () => {
    if (!emailToken || loading || disable) return;
    setLoading(true);
    newsletterUnsubscribe();
  };

  return (
    <Stack
      sx={{
        width: "100%",
        height: `calc(var(--vh,1vh) * 100)`,
        py: "20px",
        px: "24px",
        maxWidth: "660px",
        mx: "auto",
      }}
      justifyContent="center"
    >
      {unsubscribed ? (
        <Stack
          sx={{ flex: 1 }}
          justifyContent="center"
          alignItems={"center"}
          spacing={2}
        >
          <CheckLottie containerSize={"72px"} />
          <Stack justifyContent="center" alignItems={"center"} spacing={2}>
            <Typography level="h4">디스턴싱 컨텐츠 수신거부가 완료되었어요.</Typography>
            {completedAt && (
              <Typography sx={{ opacity: 0.8 }} level="body-md">
                {completedAt}
              </Typography>
            )}
          </Stack>
        </Stack>
      ) : (
        <Stack
          sx={{ flex: 1 }}
          justifyContent="center"
          alignItems={"center"}
          spacing={3}
        >
          <Typography level="h4">이메일 수신을 거부하시겠어요?</Typography>
          <Typography sx={{ opacity: 0.8 }} level="body-md" textAlign="center">
            버튼을 눌러 디스턴싱 컨텐츠 수신을 중단할 수 있어요.
          </Typography>
          <Button
            variant="solid"
            size="lg"
            color={"primary"}
            loading={loading}
            disabled={!emailToken || disable}
            onClick={handleUnsubscribe}
          >
            수신 거부
          </Button>
        </Stack>
      )}
    </Stack>
  );
}